import React, {FormEvent} from "react";
import "./styles.scss";

interface IProps {
	receiverId: number;
	notifyTyping: (clientId: number) => any;
	postMessage: (clientId: number, text: string) => any;
}

interface IState {
	isButtonDisabled: boolean;
	textarea: string;
}

class ChatFormInput extends React.Component<IProps, IState> {
	state: IState = {
		isButtonDisabled: true,
		textarea: '',
	}

	send() {
		this.props.postMessage(this.props.receiverId, this.state.textarea);
		this.setState({
			...this.state,
			textarea: '',
			isButtonDisabled: true,
		});
	}

	update(event: FormEvent<HTMLTextAreaElement>) {
		this.setState({
			...this.state,
			isButtonDisabled: !event.currentTarget.value,
			textarea: event.currentTarget.value,
		});
	}

	render() {
		return (<div className={'chat-form-input'}>
			<textarea
				placeholder={'Ваше сообщение'}
				value={this.state.textarea}
				onChange={ (e) => this.update(e) }
				onKeyPress={ () => this.props.notifyTyping(this.props.receiverId)}
			/>
			<input disabled={this.state.isButtonDisabled} type={'button'} value={'Отправить'} onClick={() => this.send()} />
		</div>);
	}
}

export default ChatFormInput;
